// 仅有一行查询条件时，混入计算table的最大高度
export default {
  data() {
    return {
      tableMaxSize: "",
      showTable: ""
    };
  },
  mounted() {
    this.resizeTableHeight();
  },
  methods: {
    // 设置table高度，计算完成后显示table
    resizeTableHeight() {
      this.tableMaxSize = window.innerHeight - 240;
      this.showTable = true;
    }
  },
  computed: {}
};
